import React from 'react';
import { GithubIcon, TwitterIcon, LinkedinIcon, MailIcon, HeartIcon } from 'lucide-react';
const Footer = () => {
  const currentYear = new Date().getFullYear();
  const footerLinks = {
    product: [{
      label: 'Features',
      href: '#'
    }, {
      label: 'Pricing',
      href: '#'
    }, {
      label: 'Integrations',
      href: '#'
    }, {
      label: 'Changelog',
      href: '#'
    }],
    resources: [{
      label: 'Documentation',
      href: '#'
    }, {
      label: 'API Reference',
      href: '#'
    }, {
      label: 'Tutorials',
      href: '#'
    }, {
      label: 'Blog',
      href: '#'
    }],
    company: [{
      label: 'About Us',
      href: '#'
    }, {
      label: 'Careers',
      href: '#'
    }, {
      label: 'Contact',
      href: '#'
    }, {
      label: 'Partners',
      href: '#'
    }],
    legal: [{
      label: 'Privacy Policy',
      href: '#'
    }, {
      label: 'Terms of Service',
      href: '#'
    }, {
      label: 'Cookie Policy',
      href: '#'
    }, {
      label: 'GDPR',
      href: '#'
    }]
  };
  const socialLinks = [{
    icon: TwitterIcon,
    href: '#',
    label: 'Twitter'
  }, {
    icon: LinkedinIcon,
    href: '#',
    label: 'LinkedIn'
  }, {
    icon: GithubIcon,
    href: '#',
    label: 'GitHub'
  }, {
    icon: MailIcon,
    href: '#',
    label: 'Email'
  }];
  return <footer className="bg-surface-elevated border-t border-custom mt-auto" data-id="element-1466">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-12" data-id="element-1467">
        {/* Main Footer Content */}
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-6 sm:gap-8 mb-8" data-id="element-1468">
          {/* Brand Section */}
          <div className="col-span-2 lg:col-span-2" data-id="element-1469">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qarEDkTctoyPPpJPJss7Dk/AA_-_horizontal_v_-_light_green_bg2x.png" alt="Ainstein Logo" className="h-8 w-auto mb-4" data-id="element-1470" />
            <p className="text-sm text-text-secondary mb-4 max-w-xs" data-id="element-1471">
              Empowering educators with AI-driven assessment tools to create
              engaging and effective learning experiences.
            </p>
            {/* Social Links */}
            <div className="flex items-center gap-2" data-id="element-1472">
              {socialLinks.map((social, index) => {
              const Icon = social.icon;
              return <a key={index} href={social.href} aria-label={social.label} className="p-2 rounded-lg bg-surface hover:bg-[#00B75F] hover:bg-opacity-10 text-text-secondary hover:text-[#00B75F] transition-all duration-200" data-id="element-1473">
                    <Icon size={18} data-id="element-1474" />
                  </a>;
            })}
            </div>
          </div>
          {/* Product Links */}
          <div data-id="element-1475">
            <h3 className="text-sm font-semibold text-text-primary mb-3 uppercase tracking-wide" data-id="element-1476">
              Product
            </h3>
            <ul className="space-y-2" data-id="element-1477">
              {footerLinks.product.map((link, index) => <li key={index} data-id="element-1478">
                  <a href={link.href} className="text-sm text-text-secondary hover:text-[#00B75F] transition-colors" data-id="element-1479">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>
          {/* Resources Links */}
          <div data-id="element-1480">
            <h3 className="text-sm font-semibold text-text-primary mb-3 uppercase tracking-wide" data-id="element-1481">
              Resources
            </h3>
            <ul className="space-y-2" data-id="element-1482">
              {footerLinks.resources.map((link, index) => <li key={index} data-id="element-1483">
                  <a href={link.href} className="text-sm text-text-secondary hover:text-[#00B75F] transition-colors" data-id="element-1484">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>
          {/* Company Links */}
          <div data-id="element-1485">
            <h3 className="text-sm font-semibold text-text-primary mb-3 uppercase tracking-wide" data-id="element-1486">
              Company
            </h3>
            <ul className="space-y-2" data-id="element-1487">
              {footerLinks.company.map((link, index) => <li key={index} data-id="element-1488">
                  <a href={link.href} className="text-sm text-text-secondary hover:text-[#00B75F] transition-colors" data-id="element-1489">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>
          {/* Legal Links */}
          <div data-id="element-1490">
            <h3 className="text-sm font-semibold text-text-primary mb-3 uppercase tracking-wide" data-id="element-1491">
              Legal
            </h3>
            <ul className="space-y-2" data-id="element-1492">
              {footerLinks.legal.map((link, index) => <li key={index} data-id="element-1493">
                  <a href={link.href} className="text-sm text-text-secondary hover:text-[#00B75F] transition-colors" data-id="element-1494">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>
        {/* Bottom Bar */}
        <div className="pt-6 border-t border-custom" data-id="element-1495">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-1496">
            <p className="text-sm text-text-secondary text-center sm:text-left" data-id="element-1497">
              © {currentYear} Ainstein. All rights reserved.
            </p>
            <p className="text-sm text-text-secondary flex items-center gap-1" data-id="element-1498">
              Made with{' '}
              <HeartIcon size={14} className="text-[#FF6CA1] fill-current" data-id="element-1499" /> by
              educators, for educators
            </p>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;